import { useSelector } from "react-redux";
import CommonBorder from "../BorderComponent/CommonBorder";
import { appName } from "../../config";
import { useTranslation } from "react-i18next";
import TermAndInfo from "../Footer/termAndInfo";
import useVersionCode from "../../hook/useVersionCode";
import usePackageVersion from "../../hook/usePackageVersion";
import LanguageSettings from "../../pages/Settings/components/LanguageSettings";
import { Divider } from "semantic-ui-react";

const SponsorFooter = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`footer.${key}`);

  const versionCode = usePackageVersion();

  const gameList = useSelector((state) => Object.keys(state.isGameList));

  return (
    <footer className="md:px-[40px] px-[20px] py-[80px] pt-[20px] bg-light-gray dark:bg-base-light-dark mt-[20px] relative">
      <section className="flex flex-nowrap md:justify-center w-full overflow-x-scroll no-scrollbar items-center gap-[5px]">
        {gameList.map((item, index) => {
          return (
            <div
              key={index}
              className="md:w-[100px] min-w-[55px] grayscale-0 cursor-pointer hover:grayscale-0 transition duration-300"
            >
              <img
                className="w-[55px]"
                src={`https://cityofwins.com/images-webp/logo/${item}.png`}
                alt={item}
              />
            </div>
          );
        })}
      </section>
      <div className="flex items-center justify-center mb-[20px]">
        <LanguageSettings />
      </div>
      <Divider />
      <TermAndInfo />
      <Divider />
      <section className="flex flex-col items-center justify-center">
        <div className="text-center text-white text-sm">
          {appName} {i18n("introduce")}
        </div>
        <p className="my-[10px] text-sm text-white">{versionCode}</p>
        <p className="font-bold mb-[5px] text-center text-main-color">
          {i18n("copyRight")} {appName}. {i18n("allRight")}
        </p>
      </section>
    </footer>
  );
};

export default SponsorFooter;
